module.exports = __webpack_public_path__ + "img/fern.5f083f44.jpg";